import axios from 'axios';

export const catalogueStkApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-catalogue`,
    headers: {
        'Content-Type': 'application/json'
    }
})